import { createActions } from 'redux-actions';

import { CompanyUser, UserList, UserLess } from '@models/User';
import { CreateUserOtpCodeParams } from '@apis/UserOtpCodeApi';
import { SaveUserParams, FindUserParams } from '@apis/UserApi';

export type State = {
  companyUsers: CompanyUser[];
  frontlineUsers: UserList[];
  servicers: UserList[];
  user?: UserLess | null;
  serverErrors: object;
  isSuccess: boolean;
};

export type OtpCodeRequestPayload = CreateUserOtpCodeParams;
export type UserFindPayload = FindUserParams;
export type UserSavePayload = SaveUserParams;
export type StateUpdatePayload = Partial<State>;

export const {
  companyUsersFetch,
  frontlineUsersFetch,
  servicersFetch,
  otpCodeRequest,
  userFind,
  userSave,
  stateUpdate,
} = createActions(
  'COMPANY_USERS_FETCH',
  'FRONTLINE_USERS_FETCH',
  'SERVICERS_FETCH',
  'OTP_CODE_REQUEST',
  'USER_FIND',
  'USER_SAVE',
  'STATE_UPDATE',
  {
    prefix: 'FEATURE_USER',
  },
);
